import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Observable, Subscription} from 'rxjs';
import { pluck, switchMap } from 'rxjs/operators';
import { NavService } from '../services/nav.service';
import { TeamNode } from 'src/app/shared/models/type-list';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource, MatTree, MatTreeNodeDef, MatTreeNode, MatTreeNodeToggle, MatNestedTreeNode, MatTreeNodeOutlet } from '@angular/material/tree';
import { LineTeam} from 'src/app/shared/models/type-list';
import { MultiTeamFilter} from 'src/app/shared/models/type-list';
import { SelectedService } from '../services/selected.service';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { ViewSelectComponent } from '../view-select/view-select.component';


@Component({
    selector: 'app-team-select-multi',
    templateUrl: './team-select-multi.component.html',
    styleUrls: ['./team-select-multi.component.scss'],
    imports: [MatTree, MatTreeNodeDef, MatTreeNode, MatTreeNodeToggle, MatIconButton, MatButton, MatNestedTreeNode, MatIcon, NgClass, MatTreeNodeOutlet, ViewSelectComponent]
})
export class TeamSelectMultiComponent implements OnInit, OnDestroy {
  
  isTablet$: Observable<BreakpointState> = this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.XSmall]);
  isScreen$: Observable<BreakpointState> = this.breakpointObserver.observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge]);

  navSubscription: Subscription; 
  teamSubscription: Subscription;
  selectionSubscription: Subscription;
  treeControl = new NestedTreeControl<TeamNode>(node => node.children);
  teamSource = new MatTreeNestedDataSource<TeamNode>();
  expandedNodes: TeamNode[] = [];
  multi_team:boolean = true;
  
  lineTeamList: LineTeam[] = [];
  PlantName = ''
  Line = ''
  subLine = ''
  display_name = ''
  
  multiTeamFilter: MultiTeamFilter = { ismultiteam: "true" }; 

  constructor(
    private navService: NavService,
    private selectedService: SelectedService,
    private route: ActivatedRoute,
    private breakpointObserver: BreakpointObserver,
  ) {
  }

  hasChild = (_: number, node: TeamNode) => !!node.children && node.children.length > 0;
  
  ngOnInit(): void {
    this.getPlantList();
    const savedNavigation = this.selectedService.getExpandedNavigationValue();
    if (savedNavigation && (savedNavigation.plant_name || savedNavigation.line || savedNavigation.subline)) {
      this.PlantName = savedNavigation.plant_name;
      this.Line = savedNavigation.line;
      this.subLine = savedNavigation.subline;
    }

    this.selectionSubscription = this.selectedService.getExpandedNavigation().subscribe(nav => {
      if(!nav || (!nav.plant_name && !nav.line && !nav.subline)){
        try {
          if(this.teamSource && this.teamSource.data){
            const collapseAll = (nodes:TeamNode[]) => {
              nodes.forEach(n => {
                if(this.treeControl.isExpanded(n)) this.treeControl.collapse(n);
                if(n.children && n.children.length) collapseAll(n.children);
              });
            };
            collapseAll(this.teamSource.data);
          }        
      } catch (e){
        console.log("Error Collpasing tree on clear:", e)
      }
      this.expandedNodes = [];
      this.PlantName = '';
      this.Line = '';
      this.subLine = '';
    }
    });
  }

  ngOnDestroy(): void {
    if (this.navSubscription) this.navSubscription.unsubscribe();
    if(this.selectionSubscription) this.selectionSubscription.unsubscribe();
  }

  
  getPlantList(){
    let navObservable: Observable<TeamNode[]> = 
    this.route.paramMap.pipe(
      switchMap((params: ParamMap) => 
      this.navService.getNavListLines(this.multiTeamFilter)), 
      pluck('Body'));
    if (this.navSubscription) this.navSubscription.unsubscribe();     
       
    this.navSubscription = navObservable.subscribe(
      (out) => {
        this.teamSource.data = out;
        if (this.route.snapshot.paramMap.get("plant_name") !== undefined && this.route.snapshot.paramMap.get("plant_name") !== null){
          this.expandTree("plant_name", out, this.route.snapshot.paramMap.get("plant_name"));
        }

        const savedNav = this.selectedService.getExpandedNavigationValue();
        if((!this.route.snapshot.paramMap.get("plant_name") || this.route.snapshot.paramMap.get("plant_name") === null) && savedNav && savedNav.plant_name){
          this.expandedNodes = [];
          this.expandTree("plant_name", out, savedNav.plant_name);
        }

        if(this.expandedNodes.length == 1){
          const lineParam = this.route.snapshot.paramMap.get("line") || (savedNav ? savedNav.line : null);
          if(lineParam) {
            this.expandTree("line", this.expandedNodes[0].children, lineParam);
          }
        }

        if(this.expandedNodes.length == 2){
          const subLineParam = this.route.snapshot.paramMap.get("subline") || (savedNav ? savedNav.subline : null);
          if(subLineParam) {
            this.expandTree("subline", this.expandedNodes[0].children, subLineParam);
          }
        }
      }
    );
  }

  navigate(plant_name: string, line: string, subline: string, team_id: number, version_id: number, display_name) {    
    subline == "" ? subline = "" : subline = subline

    this.PlantName = plant_name
    this.Line = line
    this.subLine = subline

    this.selectedService.updateExpandedNavigation({
      plant_name: plant_name,
      line: line,
      subline:subline
    });
  }
  
  expandTree(param: string, nodes: TeamNode[], paramValue?: string){

    const routeParam: string = paramValue || this.route.snapshot.paramMap.get(param);
    if (routeParam !== undefined && routeParam !== null){
      let valid = false;
      let expandedNode: TeamNode;

      nodes.forEach(node => {
        if(((node.search).toString()).toLowerCase() == routeParam.toLowerCase()){
          expandedNode = node;
          valid = true;
        }
      });

      if(valid){
        console.debug("Valid " + param + " parameter supplied, expanding " + routeParam);
        this.treeControl.toggle(expandedNode);
        this.expandedNodes.push(expandedNode);
      }else{
        console.warn("Invalid " + param + " parameter provided: " + routeParam);
      }
    }
  }

}
